// components/About.js
import React from 'react';
import { Heart, Users, MapPin, Award, Target, FileBadge} from 'lucide-react';

const About = () => (
  <section
    id="about"
    className="py-28 bg-white/30 backdrop-blur-sm"
  >
    <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12">
      
      {/* Header */}
      <div className="text-center mb-24 space-y-6">
        <h2 className="text-4xl md:text-5xl font-bold text-blue-900">
          About St.Alphonsa Charitable Trust
        </h2>
        <p className="text-xl text-blue-800 max-w-4xl mx-auto leading-relaxed">
          A beacon of hope and compassion, dedicated to transforming lives and
          building stronger communities through comprehensive charitable
          services and unwavering commitment to humanity.
        </p>
      </div>

      {/* Cards */}
      <div className="grid lg:grid-cols-3 gap-12 mb-24">

        {/* Organization Details */}
        <div className="lg:col-span-2 bg-white/40 backdrop-blur-lg rounded-2xl p-10 border border-white/30 shadow-xl">
          <h3 className="text-2xl font-bold text-blue-900 mb-10">
            Our Foundation
          </h3>

          <div className="grid md:grid-cols-2 gap-10">
            <div className="space-y-8">
              <div className="flex gap-4">
                <MapPin className="h-5 w-5 text-blue-600 mt-1" />
                <div className="space-y-1">
                  <span className="font-semibold text-blue-900">Location</span>
                  <p className="text-blue-800 leading-relaxed">
                    OOTTUPARA JUNCTION PALLIKUNNU PO, WAYANAD ,KERALA,INDIA,673122
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <Award className="h-5 w-5 text-blue-600 mt-1" />
                <div className="space-y-1">
                  <span className="font-semibold text-blue-900">Established</span>
                  <p className="text-blue-800">2024 October</p>
                </div>
              </div>
              <div className="flex gap-4">
                <FileBadge className="h-5 w-5 text-blue-600 mt-1" />
                <div className="space-y-1">
                  <span className="font-semibold text-blue-900">Registered</span>
                  <ul className="list-disc pl-6">
  <li className="text-blue-800">67/IV/2024</li>
  <li className="text-blue-800">81/IV/2024</li>
</ul>
                </div>
              </div>
            </div>

            <div className="space-y-8">
              <div className="flex gap-4">
                <Users className="h-5 w-5 text-blue-600 mt-1" />
                <div className="space-y-1">
                  <span className="font-semibold text-blue-900">
                    Beneficiaries
                  </span>
                  <p className="text-blue-800 leading-relaxed">
                    Over 40+ individuals served
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <Heart className="h-5 w-5 text-blue-600 mt-1" />
                <div className="space-y-1">
                  <span className="font-semibold text-blue-900">Volunteers</span>
                  <p className="text-blue-800">20+ active volunteers</p>
                </div>
              </div>

              <div className="flex gap-4">
                <Target className="h-5 w-5 text-blue-600 mt-1" />
                <div className="space-y-1">
                  <span className="font-semibold text-blue-900">Programs</span>
                  <p className="text-blue-800">Pain and Palliative Care </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="bg-white/40 backdrop-blur-lg rounded-2xl p-10 border border-white/30 shadow-xl">
          <h3 className="text-2xl font-bold text-blue-900 mb-10">
            Impact Statistics
          </h3>

          <div className="space-y-10 text-center">
            {[
              ['40+', 'Medical Beds Provided'],
              ['18+', 'Farmers Supported'],
              ['25+', 'Wheelchairs Distributed'],
              ['8+', 'Students Assisted'],
            ].map(([value, label]) => (
              <div key={label} className="space-y-2">
                <div className="text-3xl font-bold text-blue-600">{value}</div>
                <div className="text-sm text-blue-800">{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Purpose & Journey */}
      <div className="grid md:grid-cols-2 gap-12">
        <div className="bg-white/40 backdrop-blur-lg rounded-2xl p-10 border border-white/30 shadow-xl space-y-6">
          <h3 className="text-2xl font-bold text-blue-900">
            Our Purpose & Mission
          </h3>
          <p className="text-blue-800 leading-loose">
            St. Alphonsa Charitable Trust was founded in 2024 with a
            profound vision to create a compassionate society where no
            individual is left behind.
          </p>
          <p className="text-blue-800 leading-loose">
            We bridge critical gaps in healthcare, agriculture, disability
            support, and education through community-driven programs.
          </p>
          <p className="text-blue-800 leading-loose">
            Inspired by Saint Alphonsa, we embody selfless service and faith in
            collective action.
          </p>
        </div>

        <div className="bg-white/40 backdrop-blur-lg rounded-2xl p-10 border border-white/30 shadow-xl">
          <h3 className="text-2xl font-bold text-blue-900 mb-10">
            Our Journey & Growth
          </h3>

          <div className="space-y-6">
            {[
              ['2024 October', ' Establishment', 'Started with 20 volunteers in Wayanad'],
              ['2025 May', 'Inauguration', ' Official Inauguration of Trust Services. '],
              
            ].map(([year, title, desc]) => (
              <div key={year} className="border-l-4 border-blue-600 pl-6 space-y-1">
                <h4 className="font-semibold text-blue-900">
                  {year} – {title}
                </h4>
                <p className="text-blue-800 text-sm leading-relaxed">
                  {desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  </section>
);

export default About;
